module.exports = require("prompt");


/*****************
 ** WEBPACK FOOTER
 ** external "prompt"
 ** module id = 16
 ** module chunks = 0
 **/